import { createContext, useContext, useEffect, useState } from 'react';
import Spinners from '../components/Spinner';
import { ConfigResponseType } from '../types';
import { getApiBaseUrl } from '../utils/apiBase';

const ConfigContext = createContext<ConfigResponseType>({});

export default function ConfigContextProvider({ children }) {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchConfig() {
      const apiBase = getApiBaseUrl();
      try {
        setLoading(true);
        const result = await fetch(`${apiBase}/api/fetchConfig`);
        const jsonResult = await result.json();
        setConfig(jsonResult);
        setLoading(false);
      } catch {
        throw new Error('Exception while loading config');
      }
    }

    fetchConfig();
  }, []);

  if (loading) {
    return <Spinners />;
  }

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
}

export function useConfigContext() {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('Config Context must be used within a Provider');
  }
  return context;
}
